import React, { useContext,useEffect,useState} from 'react'

import '../../components/css/editModal.css'
import TriCheckbox from '../TriCheckbox'
import TriCheckbox2 from '../TriCheckbox2'
import Modal from './Modal'
import eye from '../../images/Icon-Eye-2023.png'
import small_square from '../../images/small_square.svg'
import small_checkmark from '../../images/small_checkmark.svg'
import { keyContext } from '../KeyContext'
import cross from '../../images/cross.png'
import alertIcon from '../../images/Icon-Altert_Small.png';
import semiCheckbox from '../../images/Semi-checked.svg'


function GroupEditModal({shown,close,data,all_events,children}) {

const key = sessionStorage.getItem("key");

const {leftMargin,arrTypes, allTicketTypes,setAllOne,setAllzero} = useContext(keyContext)
const [arrtypeSelect,setArrtypeSelect] = useState(false)
const [arrtypeName, setArrtypeName] = useState()
const [clickedNo, setClickedNo] = useState()
// const [groupTicketTypes, setGroupTicketTypes] = useState([]);
const [showArrInside, setShowArrInside] = useState(false);
const clientHeight = shown ?  document.getElementById('tes').clientHeight : ''




 const ticketTypesAdd = data.flatMap((i) =>  i.eventObject.TicketTypes_Add?.length ? i.eventObject.TicketTypes_Add : [])
 const ticketTypesRemove = data.flatMap((i) =>  i.eventObject.TicketTypes_Remove?.length ? i.eventObject.TicketTypes_Remove : [])


// arrTypes calculations and filtering
let arr_types = []

      for (let index = 0; index < data.length; index++) {
        if(data[index].name !== '') {
          arr_types.push({'index':index,'name':data[index].ArrTypeName !== null ? data[index].ArrTypeName : '' })
        }
      
      }
      // removing if name is empty of name is same in arr_types
      arr_types =  arr_types.filter((obj1, i, arr) => 
        arr.findIndex(obj2 => (obj2.name === obj1.name && obj1.name !== '' )) === i
      )
   

useEffect(() => {
   
     if(data.every( a => a.ArrTypeName === data[0].ArrTypeName) === true) {
     setShowArrInside(true)
     setArrtypeName(data[0]?.ArrTypeName)
     }
  
     else { 
       setArrtypeName(data[0]?.ArrTypeName)
      setShowArrInside(false)
  }
}, [data,shown,showArrInside]);



// priceGroups calculations and filtering
let allPriceGrps = data.flatMap((elm) => elm.priceGroups)
let allPriceGrps2 = all_events.flatMap((elm) => elm.priceGroups)
// console.log(allPriceGrps)
let filteredPrices = allPriceGrps?.filter((obj1, i, arr) =>  
 arr.findIndex(obj2 => (obj1?.Name === obj2?.Name && obj1?.Price === obj2?.Price)) === i
)
let filteredPrices2 = allPriceGrps2?.filter((obj1, i, arr) =>  
  arr.findIndex(obj2 => (obj1?.Name === obj2?.Name && obj1?.Price === obj2?.Price)) === i
 )

let PriceGroups = filteredPrices.reduce((agg,curr) => {
  let found = agg.find((x) => x.Name === curr.Name);
  if(found){
    found.Prices.sort((a,b) => a > b ? -1 : 1).push(curr.Price);
  }
  else{
     agg.push({
     Name   : curr?.Name,
     Prices : [curr?.Price]
     });
  }
  return agg;
  },[]);

  let PriceGroups2 = filteredPrices2.reduce((agg,curr) => {
    let found = agg.find((x) => x.Name === curr.Name);
    if(found){
      found.Prices.sort((a,b) => a > b ? -1 : 1).push(curr.Price);
    }
    else{
       agg.push({
       Name   : curr?.Name,
       Prices : [curr?.Price]
       });
    }
    return agg;
    },[]);

// const [priceDelete, setPriceDelete] = useState(false);
// const [newPrice, setNewPrice] = useState();
// const [priceIndex, setPriceIndex] = useState();


// const [priceChange, setPriceChange] = useState(false);



 function handlePriceChange(e,elm) {

  e.target.placeholder= ''
  data.map((item) => {
    let theEvent = item.eventObject
   
    theEvent.PriceGroups.map((i) => {
     
      if(i.Name === elm.Name ) {
       i.Price = Number(e.target.value)    
      
      }
 })
})
  
 let p = document.getElementById('isp')
    if(e.target.nextSibling.parentNode) {
        e.target.nextSibling.parentNode?.removeChild(p)
    }

 let img = document.createElement('img')
 img.style.position='absolute'
 img.style.left='75px'
 img.style.top='1px'
 img.src = alertIcon
e.target.offsetParent.appendChild(img)




 }


  // ticket types filtering
 
let chosedtickets= []    // those who have common ticket types in all 
    allTicketTypes.sort((a,b) => a.Name < b.Name ? -1 : 1).map((tk) => {     
      let tkt = tk.No   
      let ticket_types =[]
      for (let index = 0; index < data.length; index++) {
        let dat = data[index].eventObject.TicketTypes_Add?.length ? data[index].eventObject.TicketTypes.concat(data[index].eventObject.TicketTypes_Add) : data[index].eventObject.TicketTypes
        ticket_types.push({'index':index,
        'no':dat?.some(({No}) => No === tkt)
        })
      }
      if(ticket_types.every(({no}) => no === true) === true) {    
               chosedtickets.push(tk)      
      }
        return chosedtickets
    })

    const result =ticketTypesRemove[0]?.No && chosedtickets.filter(x => {
      return !ticketTypesRemove.some(t => t.No === x.No);
    })
    // result.length ? chosedtickets=result : chosedtickets=chosedtickets
    chosedtickets = result?.length ? result : chosedtickets


    const [tktDetailShown, SetTktDetailShown] = useState(true);
 const [slide_index, setSlide_index] = useState(0);
 // calculation of number of slides 
   const total_slides_with_details = Math.ceil(allTicketTypes.length/50)
    const total_slides_no_details = Math.ceil(allTicketTypes.length/100)
  const numberOfSlides = []
    const four_row_slides = []
    const total_slides = tktDetailShown === true ?  total_slides_with_details : total_slides_no_details
   
     for (let index = 0; index < total_slides; index++) {
     
     numberOfSlides.push(index);
    
  }
   for (let index = 0; index < total_slides_no_details; index++) {
     
     four_row_slides.push(index);
    
  }
  // ticket detail shown


function handleDetailView () {
  SetTktDetailShown((current => !current))
  setSlide_index(0)
  
  }

// let slideIndex = 1;

useEffect(() => {
  if(shown === true) { 
     showSlides(slide_index);
    }
    
  },[slide_index,shown,])

 
function backSlide(e) {
    e.preventDefault();

           setSlide_index((val) => {
            // console.log(val, 'val')
     
        return val - 1;
      
    });
}


function nextSlide(e) {
  e.preventDefault();

       setSlide_index((val) => {
      if (val >= numberOfSlides.length - 1) {
        return 0;
      } else {
        return val + 1;
      }
    });
}


function showSlides(n) {
  
  let i;
  let slides = document.getElementsByClassName("mySlides");

  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";  
  }
 
  
   slides ? slides[slide_index].style.display = "block" :  slides[slide_index].style.display = 'none'
  
}
     // ----search functionality------
     const [q, setQ ] = useState('')   // search word for arrtypes
     const [b,setB ] = useState('')   // search word for tickettypes
     const [searchParam] = useState(["Name"]);
     const [filterParam, setFilterParam] = useState(["Name"]);
 
      
     function search(items) {
     
       return items.filter((item) => {
        
           if (filterParam == "Name") {
               return searchParam.some((newItem) => {
                   return (
                     item[newItem] && item[newItem]
                           .toString()
                           .toLowerCase()
                           .indexOf(q || b.toLowerCase()) > -1
                   );
               });
           }
       }); 
     }
   
     function selectArrType (e) {
      
      setQ(e.target.innerText)
      // console.log(q)
      setArrtypeSelect(true)
           
     }
// console.log(PriceGroups)

   
const [arrDeleted, setArrDeleted] = useState(false);

function deleteAllArrtype() {
let items = data.filter((item) => {return item.ArrTypeName !== ''})
items.map((item) => {
       item.eventObject.ArrTypeName = ''
       item.eventObject.ArrTypeNo = ''
       arr_types=[]    
       setArrDeleted(true)
       setArrtypeName('')
 })
}

/**-----calculating price per kroner */
function calculatePrice (type) {
  let price 
  if(type.PriceType === 1) {
      price = type.Price
  }
  if(type.PriceType === 2) {
    price = type.AddPrice
  }
  if(type.PriceType === 8) {
   price= type.ProPrice+'%'
  }
  if(type.PriceType === 0) {
     
  // price = lastPrice ?  `${firstPrice +'/'+lastPrice}` : firstPrice
   }
  return price
 }

 useEffect(() => {
  let newArrtype = arrTypes.find(arr => { return arr.Name === q})
  if(newArrtype) { 
    data.map((ev) => {
     let theEvent = ev.eventObject
      theEvent.ArrTypeName = newArrtype.Name
      theEvent.ArrTypeNo = newArrtype.No
      
    })
}
 setArrtypeSelect(true)
},[q,data,arrTypes,key])


function checkTickets (tkt)  {
  //  console.log(tkt)
  let check
  let ticket_types =[]
  for (let index = 0; index < data.length; index++) {
    let dat = data[index].eventObject.TicketTypes_Add?.length ? data[index].eventObject.TicketTypes.concat(data[index].eventObject.TicketTypes_Add) 
    : data[index].eventObject.TicketTypes
    
    ticket_types.push({'index':index,
      'no':dat.some(({No}) => No === tkt)
    })
  }
 
// when tickettype is selected in all
  if(ticket_types.every(({no}) => no === true) === true && ticketTypesRemove.some(({No}) => No === tkt) === false) {
   
  check=1
  }
  // when tickettype is not selected in all
  else if(ticket_types.every(({no}) => no === false) === false && ticketTypesRemove.some(({No}) => No === tkt) === true) {
   
   
    check=0
     }
     // when tickettype is selected only in some
   else   if(ticket_types.every(({no}) => no === false) === false && ticketTypesRemove.some(({No}) => No === tkt) === false)
   {  check=2  }       
       
    return check   // if checkTickets returns 2 that means
};

function checkTickets2 (tkt) {
  
  let check
  let ticket_types =[]
  for (let index = 0; index < data.length; index++) {
    let dat =  data[index].eventObject.TicketTypes
       
    ticket_types.push({'index':index,
      'no':dat.some(({No}) => No === tkt)
    })
  }
 
// when tickettype is selected in all
  if(ticket_types.every(({no}) => no === true))  {
    //  console.log('all true') 
  check=1
  }
  // when tickettype is not selected in all
  else if(ticket_types.every(({no}) => no === false)) { 
    //  console.log(tkt, 'gives 0 returns')
    check=0
     }
     // when tickettype is selected only in some
   else   
   { 
    check=2
  }       
      //  console.log(check, 'check from check2')
    return check   // if checkTickets returns 2 that means
}
// new array object which shows status of tickettypes - 

let object_with_status = []
for (let index = 0; index < allTicketTypes.length; index++) {
  
 object_with_status.push({
      Name: allTicketTypes[index].Name,
      No: allTicketTypes[index].No,
      status: checkTickets2(allTicketTypes[index].No) === 1 ? 1 : checkTickets2(allTicketTypes[index].No) === 2 ? 2 : 0,
      click:  statusChange(allTicketTypes[index].No) === 1 ? 1 :  0
 })
  
}

const [ chosenTickets, setChosenTickets] = useState(chosedtickets);

// this funtion returns 1 if tkt.No is included in chosedTkts and object with status array and status is 2
function statusChange (No) {
  let status 
  
 object_with_status.map((obj) => {
   if(obj.status === 0 && obj.No === No) {
     status = 0
     return status
   }
   else if(obj.status === 2 && obj.No === No) {
    status = 2
    return status
   }
   else chosedtickets?.map((item) => {
    if(item?.No === No) {
     status = 1
    }
    return status
})
return status

 })
 
 return status
}

 // runs when ticketype is either selected or not selected for all
function handleChosenTicketSelect(ticket) {  
    if(checkTickets(ticket.No) === 1) {
  
  let newarr = chosenTickets.length > 1 ? chosedtickets.filter((item) => item !== ticket):  chosedtickets.filter((item) => item !== ticket)
  
              setChosenTickets(newarr)  
                  data.map((item) => {
                     let theEvent = item.eventObject   
                     theEvent.TicketTypes_Add !== null && theEvent?.TicketTypes_Add?.some(el => el.No === ticket?.No) ?
                     theEvent.TicketTypes_Add=  theEvent.TicketTypes_Add?.filter(e => e.No !== ticket?.No)          
                    : (
                       ticketTypesRemove[0] ?   
                       theEvent.TicketTypes_Remove.push({No:ticket.No}) 
                     : theEvent.TicketTypes_Remove =  [{No:ticket.No}]   // before it was removes
                    )             
                         
                     })
 }



 else {
 
           let newarr = chosenTickets.length > 1 ? [...chosenTickets, ticket] :  [...chosedtickets, ticket]
         setChosenTickets(newarr)  
       
              data.map((item) => {
              let theEvent = item.eventObject
              theEvent?.TicketTypes_Remove?.some(el => el.No === ticket?.No) ?
              theEvent.TicketTypes_Remove =  theEvent.TicketTypes_Remove?.filter(e => e.No !== ticket?.No)
          :        
           (
          ticketTypesAdd[0] ?         
               theEvent.TicketTypes_Add.push({No:ticket.No})     
             : theEvent.TicketTypes_Add = [{No:ticket.No}]     
          )
       
            })
 }
    

  }

 
function checkForAlertonChosen(item){
  let showAlert    
 
  ticketTypesAdd.length > 0 && ticketTypesAdd?.map(tr => {
   
    if (tr.No === item.No) {
        showAlert= true
     return showAlert
    }      
   })    
 
  return showAlert
}


  function checkForAlertonNotChosen(item){
  let showAlert      
  ticketTypesRemove.length > 0 && ticketTypesRemove?.map(tr => {
    if (tr.No === item.No) {
        showAlert= true
     return showAlert
    }      
   })    
  return showAlert
}


// check of UsePriceGroupTemplate
  const [price_rule_check, setPrice_rule_check] = useState();

  useEffect(() => {
    let price_rules = []
      for (let index = 0; index < data.length; index++) {
       let arr = data[index].UsePriceGroupTemplate
        price_rules.push(arr)
      }
       setPrice_rule_check(price_rules.every((x) => x === 1) === true ? 1 : price_rules.every((x) => x === 0) === true ? 0 : 2)
  }, [data]);


  const [priceRuleclicked, setPriceRuleclicked] = useState(false);
  const [ticketRuleClicked,setTicketRuleClicked ]= useState(false);

 function handlePriceRule () {
  
  setPriceRuleclicked(true)
  setPrice_count((current) => !current)
  setPriceChanged((current) => !current)
 }

//if price rule check is 2---1)on first click change it to 1, on second click change it to 0 and on third click change it to 2
 const [price_count, setPrice_count] = useState(false);
 const [price_count2, setPrice_count2] = useState(2);

useEffect(() => {
  setPrice_count(price_rule_check === 1 ? true : false)
}, [price_rule_check]);

const [priceRule2clicked, setPriceRule2clicked] = useState(false);

 function handlePriceRule2 () {
  setPriceRule2clicked(true)
  setPrice_count2((price_count2+1)%3)
 }

useEffect(() => {
  
  if(priceRuleclicked === true) {
    
     if(price_count === true) {
        data.map((item) => {
          let theEvent = item.eventObject
          theEvent.UsePriceGroupTemplate = 1
      
    })
    // setPrice_rule_check(1)
  }
  else {
    data.map((item) => {
      let theEvent = item.eventObject
      theEvent.UsePriceGroupTemplate = 0
     
    })
    // setPrice_rule_check(0)
  }
  }
}, [priceRuleclicked,data,price_count]);


useEffect(() => {
  if(priceRule2clicked === true ) {
      if(price_count2 === 0 ) { 
    // set to 1
   
    data.map((item) => {
    let theEvent = item.eventObject
    theEvent.UsePriceGroupTemplate = 1
    // setGroupArr(theEvent)
  
   
  })
}
  else if(price_count2 === 1) {
  // set to 0
 
  data.map((item) => {
    let theEvent = item.eventObject
    theEvent.UsePriceGroupTemplate = 0
    
  })
}
  else {
    data.map((item) => {
      let theEvent = item.eventObject
      theEvent.UsePriceGroupTemplate = item.UsePriceGroupTemplate
     
    })
}

}
}, [data,price_count2,priceRule2clicked]);


 const [ticket_rule_check, setTicket_rule_check] = useState();
 const [ticket_count, setTicket_count] = useState(false);
 const [ticket_count2, setTicket_count2] = useState(2);

 useEffect(() => {
  let ticket_rules = []
  for (let index = 0; index < data.length; index++) {
    let arr = data[index].eventObject.UseTicketTypeTemplate
    ticket_rules.push(arr) 
  }
 setTicket_rule_check(ticket_rules.every((x) => x === 1) === true ? 1 : ticket_rules.every((x) => x === 0) === true ? 0 : 2)

 }, [data,ticket_rule_check]);
 
 function handleTicketRule () {
  
   setTicket_count((current) => !current)
   setTicketRuleClicked(true)
   setTickettypeChanged((current) => !current)
 }

 useEffect(() => {
  setTicket_count(ticket_rule_check === 1 ? true : false)
 }, [ticket_rule_check]);

 useEffect(() => { 
  if(ticketRuleClicked === true) {
      if(ticket_count === true) {
         data.map((item) => {
            let theEvent = item.eventObject
            theEvent.UseTicketTypeTemplate = 1
       })
    }
  
   else {
     data.map((item) => {
       let theEvent = item.eventObject
       theEvent.UseTicketTypeTemplate = 0
      })
    }
  }
  
 }, [ticketRuleClicked,data,ticket_count]);

const [ticketRule2clicked, setticketRule2clicked] = useState(false);
function handleTicketRule2(){
  setticketRule2clicked(true)
  setTicket_count2((ticket_count2 + 1)%3)
}
useEffect(() => {
  if(ticketRule2clicked === true ) {
    if(ticket_count2 === 0) {
      data.map((item) => {
        let theEvent = item.eventObject
        theEvent.UseTicketTypeTemplate = 1
      })
    }
    else if(ticket_count2 === 1) {
      data.map((item) => {
        let theEvent = item.eventObject
        theEvent.UseTicketTypeTemplate = 0
      })
    }
    else {
      data.map((item) => {
        let theEvent = item.eventObject
        theEvent.UseTicketTypeTemplate = item.UseTicketTypeTemplate
      })
    }
  }
}, [data,ticket_count2,ticketRule2clicked]);
  function handleArrtypeChange (e) {
  setQ(e.target.value.toLowerCase())
setarrtypechange(true)

  }
  const [priceChanged, setPriceChanged] = useState(false);
  const [tickettypeChanged, setTickettypeChanged] = useState(false);
  const [priceflag, setPriceflag] = useState();
  const [tickettypeflag, setTickettypeflag] = useState();

  useEffect(() => {
    setPriceChanged( priceflag === 1 ? true : false)
  }, [priceflag]);
  useEffect(() => {
    setTickettypeChanged( tickettypeflag === 1 ? true : false)
  }, [tickettypeflag]);

  const [arrtypechange, setarrtypechange] = useState(false);
  
 
  const windowHeight = window.innerHeight

 let tktCount = 0;


  return shown? (
    <Modal open={shown}>
    <div  >
    {children}
              <section className='modalContainer'  style={{backgroundColor:'#F1F5F9',border:'1px solid var(--Red, #982F2F)',borderRadius:'9px',height:'974px',width:'1176px',position:windowHeight> 1000 ?'absolute':'',top:windowHeight> 1000 ? '50%' : '69px',left:windowHeight > 1000 ? '50%': '',transform: windowHeight > 1000 ? 'translate(-50%,-50%)':''}} >
            
              <div className='modal_title' style={{backgroundColor:'rgba(0,0,0,0.1)'}}>
                <span style={{marginRight:'40px',}}>Rediger Valgte</span>
                
                <span  onClick={() => {
              // close modal when outside of modal is clicked
              close();
              setShowArrInside(false)
            }} style={{float:'right',marginRight:'15px',cursor:'pointer',}}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.24422 6.47669C7.16425 6.39984 7.11993 6.29825 7.11993 6.19021C7.11993 6.08127 7.16472 5.9788 7.24586 5.90172L9.35649 3.89654C9.364 3.88963 9.36916 3.88139 9.37596 3.87404L11.8053 1.56633C12.0649 1.31972 12.0649 0.919848 11.8053 0.673238C11.5457 0.426629 11.125 0.426629 10.8651 0.673238L8.4386 2.97827C8.42875 2.98673 8.41749 2.99297 8.40811 3.0021L6.29701 5.00684C6.14176 5.15409 5.89834 5.16322 5.72996 5.03825L1.13488 0.673238C0.875268 0.426629 0.454548 0.426629 0.194706 0.673238C-0.0649019 0.919848 -0.0649019 1.31972 0.194706 1.56633L2.60294 3.85399C2.6149 3.86735 2.62451 3.88183 2.63765 3.89431L4.74851 5.89971C4.82965 5.97657 4.87445 6.07904 4.87445 6.18798C4.87445 6.29669 4.82965 6.39917 4.74851 6.47625L2.63765 8.48142C2.62451 8.4939 2.6149 8.5086 2.60294 8.52175L0.194706 10.8094C-0.0649019 11.056 -0.0649019 11.4559 0.194706 11.7025C0.324627 11.8259 0.49465 11.8874 0.664908 11.8874C0.834931 11.8874 1.00519 11.8259 1.13488 11.7025L3.57219 9.38722C3.57688 9.38299 3.58227 9.38031 3.58673 9.37608L5.69783 7.37112C5.86551 7.21206 6.13778 7.21206 6.30546 7.37135L8.41656 9.37675L10.8651 11.7025C10.995 11.8259 11.1651 11.8874 11.3353 11.8874C11.5054 11.8874 11.6756 11.8259 11.8053 11.7025C12.0649 11.4559 12.0649 11.056 11.8053 10.8094L7.24422 6.47669Z" fill="#282828"/>
         </svg>
                </span>
              </div>
           <div className='modal_desc' >
           <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',marginRight:'30px',height:'200px'}}>
            
                 <div style={{paddingLeft:'30px',paddingTop:'25px'}}>
                 
                  <div style={{width:'278px',display:'flex',justifyContent:'space-between',margin:0,padding:0}}>
                      <p style={{fontWeight:'bold',height:'15px',letterSpacing:'0.32px',color:'#528398'}}>Prisgrupper</p>
                      <div style={{fontSize:'12px',width:'149px',marginTop:'5px',position:'relative'}}> 
                        { price_rule_check === 2 ?
                         <img onClick={handlePriceRule2} 
                        src={ price_count2 === 0 ? small_checkmark : price_count2 === 1 ? small_square :  semiCheckbox} alt='semicheckbox'/> :                       
                        <img onClick={handlePriceRule} src={price_count === true ? small_checkmark :  small_square } alt='checkbox'/>} 
                        <span style={{marginLeft:'5px'}}>Brug prisgrupperegler</span>  
                      { priceChanged === true ?  <img style={{top:'3px',right:'-3px',position:'absolute'}} src={alertIcon} alt='alert-icon' /> : ''} 
                      </div>

                  </div>                                
                    <div style={{width:'200px',display:'flex',justifyContent:'space-between',fontSize:'12px',margin:0,padding:0}}>
                      <div style={{}}>
                         <p style={{height:'5px',fontWeight:'bold'}}>Navn</p>
                      </div>
                      <div>
                         <p style={{height:'8px',fontWeight:'bold',width:'73px'}}>Pris kr.</p>                       
                      </div>                        
                    </div>
                   
                    { PriceGroups?.map((elm,index) => {
                      return <div key={index} style={{width:'200px',display:'flex',justifyContent:'space-between',fontSize:'12px',margin:0,padding:0,height:'19px'}}>
                        <div>
                          <p style={{width:'128px'}}>{elm.Name}</p>
                        </div>
                     {elm.Prices &&   <div style={{marginTop:'3px',marginRight:'3px',position:'relative'}}> 
                          <input style={{width:'73px',height:'14px',display:'block',marginBottom:'3px',textAlign:'right'}}  onChange={(e)=>handlePriceChange(e,elm)}  placeholder={elm.Prices.length === 1 ? elm.Prices[0]:''}/>
                          
                          <p id='isp' style={{position:'absolute', left:'75px', top:'-2px',display:'flex'}}>
                   {elm.Prices.length > 1  ? 
                        elm.Prices.sort((a,b) => a > b ? 1 : -1).map((price,index) => ( 
                        <span>{price}{index+1 < elm.Prices.length  ? ', ':''}</span>))
                       
                        : ''
                        }
                          </p>

                        </div> 
                        
                        } 
                       
                       
                      </div>
                    })}

                 </div>
             <div>
                 <div style={{paddingTop:'25px',position:'relative',left:'40px'}}>
                  <p style={{fontWeight:'bold',letterSpacing:'0.32px',color:'#528398'}}>Forestillingtype</p>
                  <input  name="" id=""  
                   value={  q ? q:   showArrInside === true  ?  arrtypeName : ''}
                             onChange={(e) =>handleArrtypeChange(e) }
                             style={{width:'500px',paddingLeft:'40px'}} 
                            />                    
                  <div style={{border: q &&  search(arrTypes) ? '1px solid #8b8b8b' : '1px',backgroundColor:'white',position:'absolute',right:'74px',left:0,zIndex:1}}> 
                 { q && search(arrTypes).map((item) => (
                     
                       <p style={{padding:0,margin:0,paddingLeft:'10px',fontSize:'12px'}} 
                       onClick={ (e) => selectArrType(e)}>{item.Name}</p>                                           
                    )
                    )}   
                  </div>
                
                <span style={{position:'absolute', top:'67px',left:'8px'}}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8709 15.4795L11.8948 11.5157C12.9783 10.1946 13.5111 8.50888 13.3828 6.8072C13.2546 5.10553 12.4751 3.51809 11.2058 2.37324C9.93639 1.22839 8.27418 0.613723 6.56295 0.656377C4.85172 0.699031 3.2224 1.39574 2.012 2.6024C0.801605 3.80906 0.102734 5.43335 0.059948 7.13929C0.017162 8.84523 0.633734 10.5023 1.78213 11.7678C2.93053 13.0332 4.52288 13.8102 6.22984 13.9381C7.93679 14.0659 9.62773 13.5348 10.9529 12.4547L14.929 16.4185C15.0546 16.5394 15.2229 16.6064 15.3975 16.6048C15.5722 16.6033 15.7393 16.5335 15.8628 16.4104C15.9863 16.2872 16.0563 16.1207 16.0578 15.9466C16.0594 15.7725 15.9922 15.6047 15.8709 15.4795ZM6.74038 12.6287C5.68641 12.6287 4.65611 12.3171 3.77977 11.7333C2.90342 11.1496 2.2204 10.3199 1.81706 9.34917C1.41373 8.37844 1.3082 7.31027 1.51382 6.27975C1.71943 5.24923 2.22697 4.30263 2.97224 3.55967C3.7175 2.8167 4.66703 2.31074 5.70075 2.10575C6.73446 1.90077 7.80594 2.00597 8.77968 2.40806C9.75342 2.81015 10.5857 3.49107 11.1712 4.3647C11.7568 5.23834 12.0693 6.26545 12.0693 7.31616C12.0677 8.72464 11.5058 10.075 10.5068 11.0709C9.50773 12.0669 8.15321 12.6271 6.74038 12.6287Z" fill="#323232"/>
                </svg>
                 
                </span>
                <span style={{position:'absolute',right:'78px',top:'65px'}}>
                 {(q ||  arrtypeName) &&   <img src={cross} alt="" onClick={deleteAllArrtype}/> }
                </span>  
                 {arrtypechange === true ? <img style={{marginLeft:'5px'}} src={alertIcon} alt= 'alert-icon'/> : ''}          
                 </div>
                 { (data.length > 1 && arr_types.length  && !q  && showArrInside === false && arrDeleted === false ) ?
                 <p style={{color:'#46484c',fontWeight:700,letterSpacing:'0.32px',paddingLeft:'40px',paddingTop:'11px'}}>
                  Du har valgt: {
                  arr_types&&arr_types.map((arr,index) => (
                 
                       <span>{arr.name }{index+1 < arr_types.length ? ', ':''}</span>
                    ))} 
                    <button style={{color:'#46484c'}}  onClick={deleteAllArrtype}>{q || arrtypeName ? 'x' : ''}</button>
                    </p> :'' }
                 </div>


</div>
<div>
<div style={{left:'30px ',position:'relative',width:'500px',}}>
                  <p style={{fontWeight:'bold',height:'18px',letterSpacing:'0.32px',color:'#528398'}}>Billettyper</p>
                  <input type="search" name="" id="search_input" style={{paddingLeft:'30px',width:'100%',height:'32px'}} 
                   value={b} onChange={(e) => setB(e.target.value)} placeholder='Søg'
                  />
                  
                <span>
                <span style={{position:'absolute', top:'36px',left:'8px'}}>
                
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8709 15.4795L11.8948 11.5157C12.9783 10.1946 13.5111 8.50888 13.3828 6.8072C13.2546 5.10553 12.4751 3.51809 11.2058 2.37324C9.93639 1.22839 8.27418 0.613723 6.56295 0.656377C4.85172 0.699031 3.2224 1.39574 2.012 2.6024C0.801605 3.80906 0.102734 5.43335 0.059948 7.13929C0.017162 8.84523 0.633734 10.5023 1.78213 11.7678C2.93053 13.0332 4.52288 13.8102 6.22984 13.9381C7.93679 14.0659 9.62773 13.5348 10.9529 12.4547L14.929 16.4185C15.0546 16.5394 15.2229 16.6064 15.3975 16.6048C15.5722 16.6033 15.7393 16.5335 15.8628 16.4104C15.9863 16.2872 16.0563 16.1207 16.0578 15.9466C16.0594 15.7725 15.9922 15.6047 15.8709 15.4795ZM6.74038 12.6287C5.68641 12.6287 4.65611 12.3171 3.77977 11.7333C2.90342 11.1496 2.2204 10.3199 1.81706 9.34917C1.41373 8.37844 1.3082 7.31027 1.51382 6.27975C1.71943 5.24923 2.22697 4.30263 2.97224 3.55967C3.7175 2.8167 4.66703 2.31074 5.70075 2.10575C6.73446 1.90077 7.80594 2.00597 8.77968 2.40806C9.75342 2.81015 10.5857 3.49107 11.1712 4.3647C11.7568 5.23834 12.0693 6.26545 12.0693 7.31616C12.0677 8.72464 11.5058 10.075 10.5068 11.0709C9.50773 12.0669 8.15321 12.6271 6.74038 12.6287Z" fill="#323232"/>
</svg>
                  </span>

                  </span>
                 </div>
                 <div style={{marginLeft:'30px',marginTop:'40px',  display:'flex',justifyContent:'space-between',width:'325px'}}>
                      <p style={{fontWeight:'bold',height:'18px',letterSpacing:'0.32px',fontSize:'16px',color:'#528398'}}>Overblik</p>
                      <div style={{fontSize:'12px',marginTop:'5px'}}> 
                        <img onClick={handleDetailView} src={tktDetailShown === true ?  small_checkmark : small_square} style={{paddingTop:'2px',paddingRight:'5px'}} alt='checkmark'/> 
                      Vis detaljer </div>            
                      <div  style={{fontSize:'12px',marginTop:'5px',position:'relative'}}>
                        {ticket_rule_check === 2 ? 
                        <img onClick={handleTicketRule2}
                      src={ticket_count2 === 0 ? small_checkmark : ticket_count2 === 1 ? small_square : semiCheckbox} alt="" /> 
                      : 
                      <img onClick={handleTicketRule} src={ticket_count === true ? small_checkmark : small_square } alt='checkmark'/> }
                      <span style={{marginLeft:'5px'}}>Brug billettyperegler</span>
                       {tickettypeChanged === true ?  <img style={{top:'3px',right:'-15px',position:'absolute'}} src={alertIcon} alt='alert-icon' /> : ''}

                      </div>
                 </div>
     <div className='slideshow-container'>
      {numberOfSlides.map((slide) => (
        <>
         <div className='mySlides fades' >
            <div  style={{border:'1px ', display:'flex',padding:'0px 30px'}}>
               {/* div 1 */}   
              <div style={{marginRight:'35px'}}>
              <div style={{display:'grid',width:tktDetailShown === true ?'500px':'250px',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',gridTemplateColumns: tktDetailShown === true ? '0.7fr .4fr .4fr .24fr .2fr' : '.1fr 1fr',height:'20px',letterSpacing:'0.24px'}}>
                   <p style={{fontWeight:'bold',paddingLeft:'0px'}}>Tilføjet</p>
                   { tktDetailShown === true ?
                   <>
                   <p style={{fontWeight:'bold',textAlign:'center',width:'78px'}}>Website</p>
                   <p style={{fontWeight:'bold',width:'72px',textAlign:'center'}}>Bundlesalg</p>
                   <img style={{paddingRight:'20px'}} src={eye} alt="" />
                   <p style={{fontWeight:'bold'}}>Pris kr.</p> 
                   </>
                   : ''}
                  </div>  
                  <div style={{border:'1px solid #8b8b8b',
                    width:tktDetailShown === false ? '250px':'535px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                  
                 {b ? 
                  search(allTicketTypes).map((tkt) => (
                   <div  style={{display:'grid',
                   gridTemplateColumns: tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',backgroundColor:clickedNo === tkt.No ? '#982f2f' : '',color:clickedNo === tkt.No ? 'white' : ''}} 
                   onClick={(e) =>  handleChosenTicketSelect(e,tkt)}
                   >
                   <input type="checkbox" name="" id="" />
                   <p  style={{padding:0,margin:0}}>{tkt.Name}</p>
                { tktDetailShown === true ? <>
                   <p  style={{padding:0,margin:0,}}>
                     {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                     {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                      {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''}</p>
                   <p  style={{padding:0,margin:0,}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+'stk' : ''}</p>
                     {tkt.Hide === 0 ? <p></p> : <img style={{paddingLeft:'0px'}} alt='checkmark'/> }              
                   <p  style={{paddingLeft:'8px',margin:0,width:'50px'}}>
                     {calculatePrice(tkt)}
                     </p>
                     </> : ''}
                     { checkForAlertonChosen(tkt) === true &&  <img style={{}} src={alertIcon} alt='alert-icon' />}
                   </div>
                ))
                : 
                allTicketTypes.sort((a,b) => a.Name < b.Name ? -1 : 1)
                .slice(slide === 0 ? 0 :  tktDetailShown === true ? slide*50 : 
                       slide*100                    ,
                     slide === 0 ? 25 : tktDetailShown === true ? 
                slide*50+25 : slide * 100+25).map((tkt,index) => (                               
                  <>        
             <span style={{position:'absolute', left:slide*100+index+1 > 99 ? '8px': '8px',  fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:slide*100+index+1 > 99 ? '20px':'20px',marginTop:'0px'}}>
              { slide === 0  ? index+1 : tktDetailShown === true ?
               slide*50+index+1 : slide*100+index+1 } 
             </span>
            
 {  checkTickets2(tkt.No) === 2  ? 
         <TriCheckbox data={data} ticket={tkt} add={ticketTypesAdd} object_with_status={object_with_status} chosedtickets= {chosedtickets} index={index} tktDetailShown={tktDetailShown} /> 
         : 
         <div key={index} style={{display:'grid',
                gridTemplateColumns:tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} 
                 >                
             <img style={{padding:'2px'}} onClick={()=> handleChosenTicketSelect(tkt) }
                   src={ chosenTickets.length > 1 ?  chosenTickets.includes(tkt) ? small_checkmark : small_square : 
                   chosedtickets.includes(tkt)  ? small_checkmark : small_square
                   }   alt="checkmark" />
                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                    {tktDetailShown === true ? <> 
                  <p style={{padding:'0 0 0 0px',margin:0,}}>
                    {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                    {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                    {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''}                    
                  </p>
                  <p  style={{padding:0,margin:0,paddingLeft:'0px'}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+' stk' : 'Ikke muligt'}</p>
                    <img src={tkt.Hide === 0 ?  small_square : small_checkmark} style={{paddingTop:'2px'}} alt='checkmark'/>                 
                  <p  style={{padding:0,margin:0,textAlign:'center',width:'50px'}}>
                     {calculatePrice(tkt)}
                  </p>                              
</> : ''}

{ checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{paddingTop:'2px'}} src={alertIcon} alt='alert-icon' /> : ''}
                  </div> 
                  }
                  </>
                 )
                )
              }        
      </div>
              </div>
 {/* div 2 */}
 { !b.length && (allTicketTypes.length > (slide === 0 ?  25 : tktDetailShown === true ? slide*50+25 : slide*100+25 )) ?
             <div style={{position:'relative',marginRight:'35px'}}>
                 <div style={{display:'grid',width:tktDetailShown === true ? '500px' : '250px',fontSize:'12px',fontWeight:'bold',marginTop:'20px',     gridTemplateColumns:tktDetailShown === true ? '0.82fr .4fr .4fr .23fr .2fr' : '.1fr 1fr',height:'20px',letterSpacing:'0.24px'}}>
                   <p style={{fontWeight:'bold',paddingLeft:'0px'}}>Tilføjet</p>
                   { tktDetailShown === true ?
                   <>
                   <p style={{fontWeight:'bold',width:'54px'}}>Website</p>
                   <p style={{fontWeight:'bold'}}>Bundlesalg</p>
                   <img style={{paddingRight:'20px'}} src={eye} alt="" />
                   <p style={{fontWeight:'bold'}}>Pris kr.</p> </>
                   : ''}
                </div>
             
                <div style={{border:'1px solid #8b8b8b',width:tktDetailShown === true ?'545px' : '250px',height:'462px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                  
                 
            {    allTicketTypes.sort((a,b) => a.Name < b.Name ? -1 : 1)
                 .slice(slide === 0 ?  25 : tktDetailShown === true ?  slide*50+25 : slide *100+25, slide === 0 ?  50 : tktDetailShown === true ?  slide*50+50 :  slide*100+50).map((tkt,index) => {
                   tktCount =   slide*100+index+26
            return   <>
            
                <span style={{position:'absolute', left : '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:slide*100+index+26 > 99 ? '20px':'20px',marginTop:'0px'}}>
                  {slide === 0 ? index+26 : tktDetailShown === true ?  slide*50+index+26 : slide*100+index+26}
                  </span>

                  {  checkTickets2(tkt.No) === 2  ? <TriCheckbox data={data} ticket={tkt} add={ticketTypesAdd} object_with_status={object_with_status} chosedtickets= {chosedtickets} index={index} tktDetailShown={tktDetailShown}/> : 
              <div key={index} style={{display:'grid',
                gridTemplateColumns:tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} 
                 >                
             <img style={{padding:'2px'}} onClick={()=> handleChosenTicketSelect(tkt) }
                   src={ chosenTickets.length > 1 ?  chosenTickets.includes(tkt) ? small_checkmark : small_square : 
                   chosedtickets.includes(tkt)  ? small_checkmark : small_square
                   }   alt="checkmark" />
                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                    {tktDetailShown === true ? <> 
                  <p style={{padding:'0 0 0 0px',margin:0,}}>
                    {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                    {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                    {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''}                    
                  </p>
                  <p  style={{padding:0,margin:0,paddingLeft:'0px'}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+' stk' : 'Ikke muligt'}</p>
                    <img src={tkt.Hide === 0 ?  small_square : small_checkmark} style={{paddingTop:'2px'}} alt='checkmark'/>                 
                  <p  style={{padding:0,margin:0,textAlign:'center',width:'50px'}}>
                     {calculatePrice(tkt)}
                  </p>                              
</> : ''}

{ checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{paddingTop:'2px'}} src={alertIcon} alt='alert-icon' /> : ''}
                  </div> 
                  }
                  </>
                 }
                )} 
                     
      </div>
             </div>                                                         
             : ''}
            {/* div 3 and div 4 */}
            {  tktDetailShown === false && !b  && tktCount < allTicketTypes.length?
           <>
           {(allTicketTypes.length > (slide === 0 ?  50  : slide*100+25 )) &&  
           <div style={{position:'relative',marginRight:'35px'}}>
            <div style={{display:'grid',gridTemplateColumns:'1 fr',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',height:'20px',letterSpacing:'0.24px'}}>
                <p>Tilføjet 3</p>
            </div>
            <div style={{border:'1px solid #8b8b8b',
                    width: '250px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                       {
                allTicketTypes.sort((a,b) => a.Name < b.Name ? -1 : 1)
                .slice(slide === 0 ? 50 : slide*100, slide === 0 ? 50+25 : slide*100+25).map((tkt,index) => {
                     tktCount =  slide*100+index+1+50
          return    <>
             
               <span style={{position:'absolute', left:  '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:'15px',marginTop:'0px'}}>{slide === 0 ? 50+index+1 : slide*100+index+1+50}</span>
     { checkTickets2(tkt.No) === 2 ? 
               <TriCheckbox2 data={data} ticket={tkt} add={ticketTypesAdd} object_with_status={object_with_status} chosedtickets= {chosedtickets} index={index} tktDetailShown={tktDetailShown} />
               : 
                <div key={index} style={{display:'grid',
                gridTemplateColumns:'.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} >
                <img onClick={() => handleChosenTicketSelect(tkt)} style={{padding:'2px'}} 
                  src={ chosenTickets.length > 1 ?  chosenTickets.includes(tkt) ? small_checkmark : small_square : 
                    chosedtickets.includes(tkt)  ? small_checkmark : small_square
                    }
                  //  src={checkTickets(tkt.No) === 1 ? small_checkmark : checkTickets(tkt.No) === 0 ? small_square : ''  }  
                    alt="checkmark" />

                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                 
                 
                  { checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{}} src={alertIcon} alt='alert-icon' /> : ''}
  
                  </div>
                  }
                  </>
                }
                )
              }     
            </div>
           </div>
          }
          {(allTicketTypes.length > (slide === 0 ?  50 : tktDetailShown === true ? slide*50+25 : slide*100+25 ))  && numberOfSlides[slide] === slide &&  tktCount < allTicketTypes.length &&
           <div  style={{position:'relative',marginRight:'35px'}}>
            <div style={{display:'grid',gridTemplateColumns:'1 fr',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',height:'20px',letterSpacing:'0.24px'}}>
                <p>Tilføjet</p>
            </div>
            <div style={{border:'1px solid #8b8b8b',
                    width: '250px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                       {
                allTicketTypes.sort((a,b) => a.Name < b.Name ? -1 : 1)
                .slice( slide === 0 ? 75 : slide*100+75 ,slide === 0 ? 75+25 : slide*100+100).map((tkt,index) => {
              tktCount = slide*100+index+1+75
         return   <>
             
             <span style={{position:'absolute', left:  '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:'20px',marginTop:'0px'}}>{slide === 0 ? 75+index+1 : tktDetailShown === true ?  slide*50+index+1 : slide*100+index+1+75}</span>

              { checkTickets2(tkt.No) === 2 ? 
               <TriCheckbox2 data={data} ticket={tkt} add={ticketTypesAdd} object_with_status={object_with_status} chosedtickets= {chosedtickets} index={index} tktDetailShown={tktDetailShown} />
               : 
                <div key={index} style={{display:'grid',
                gridTemplateColumns:'.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} >
                <img onClick={() => handleChosenTicketSelect(tkt)} style={{padding:'2px'}} 
                  src={ chosenTickets.length > 1 ?  chosenTickets.includes(tkt) ? small_checkmark : small_square : 
                    chosedtickets.includes(tkt)  ? small_checkmark : small_square
                    }
                  //  src={checkTickets(tkt.No) === 1 ? small_checkmark : checkTickets(tkt.No) === 0 ? small_square : ''  }  
                    alt="checkmark" />

                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                 
                 
                  { checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{}} src={alertIcon} alt='alert-icon' /> : ''}
  
                  </div>
                  }
                  </>
                }
                )
              }     
                    </div>
           </div>
          }
           </>
            : ''}  
            </div>
            { tktDetailShown === true ? 
          <div style={{border:'1px ', display:'flex',margin:'30px',justifyContent:'space-between'}}>
             <button className='prev' disabled={slide=== 0 ?true:false} style={{opacity:slide=== 0  ? '0.5':'1', }}  onClick={(e) => {  backSlide(e)}}>❮ forrige billettyper</button>
             <p style={{paddingTop:'10px',fontSize:'12px',letterSpacing:'0.24px',color:'#46484c'}}>
              viser {slide === 0 ? '1' : slide*50+1}-{slide === 0 && allTicketTypes.length > 50 ? 50 : slide+1 === numberOfSlides.length ? allTicketTypes.length : slide*50+50 } ud af i alt {allTicketTypes.length}  billettyper</p>
             <button className='next' disabled={ slide === numberOfSlides.slice(-1)[0] ? true : false} style={{opacity: slide === numberOfSlides.slice(-1)[0] ? '0.5':'1', }} onClick={(e) => {nextSlide(e)}}>næste billettyper ❯</button>
          </div>
          : 
          <div style={{border:'1px ', display:'flex',margin:'30px',justifyContent:'space-between'}}>
             <button className='prev' disabled={slide=== 0 ?true:false} style={{opacity:slide=== 0  ? '0.5':'1', }}  onClick={(e) => { backSlide(e)}}>❮ forrige billettyper</button>
             <p style={{paddingTop:'10px',fontSize:'12px',letterSpacing:'0.24px',color:'#46484c'}}>
              viser {slide === 0 ? '1' : slide*100+1} - 
              {slide === 0 && allTicketTypes.length > 100 ? 100    
               : slide+1 === numberOfSlides.length ? allTicketTypes.length 
              : slide*100+100 } {''} 
              ud af i alt {allTicketTypes.length}  billettyper</p>
             <button className='next' disabled={
               slide === four_row_slides.slice(-1)[0]
              
              } 
               onClick={(e) => {nextSlide(e)}}>næste billettyper ❯</button>
          </div>
          }
         </div>
        </>
      ))}
     
    
      </div>            
</div>
           </div>
              </section>
   
    

    </div>
    </Modal>
  ) : ''
}

export default GroupEditModal